module.exports = "/images/cooper-3.jpg";